import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { API_STATUS } from "../../sliceUtil";
import { _delete, _get, _post, _put } from "../../../../api/apiClient";
import store from "../../../../app/store";
import { CustomError } from "../../../../api/CustomError";
import { CustomSuccess } from "../../../../api/CustomSuccess";
import {
  setLoaderFalse,
  setLoaderTrue,
  setPerformaLoading,
} from "../../../../Redux/loaderSlice";

const initialConsumerListState = {
  consumerList: [],
  isLoading: API_STATUS.STATUS_IDLE,
  totalCount: 0,
};

const base_url = process.env.REACT_APP_API_URL;
const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId;
};

export const fetchConsumerList = createAsyncThunk(
  "consumersList/fetchConsumerList",
  async (
    { paginationObj, disableLoader, isConsumerList, cardName },
    thunkAPI,
  ) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setPerformaLoading(true));
      const config = {
        successMessage: "Fetched Consumer successfully.",
        errorMessage: "Failed to fetch consumer!",
      };

      const _searchby = cardName
        ? `searchby=${cardName}`
        : paginationObj.searchData
          ? `searchby=${paginationObj.searchData}`
          : "";
      const _limit = paginationObj?.limit
        ? `&PageSize=${paginationObj?.limit}`
        : "&PageSize=0";
      const _offset = paginationObj?.currentPage
        ? `&PageNumber=${paginationObj?.currentPage}`
        : "&PageNumber=1";
      const _status = paginationObj?.selectedFilter?.code
        ? `&Status=${paginationObj?.selectedFilter?.code}`
        : "";
      const _orderby = paginationObj?.sortObj?.sortOrder
        ? `&orderby=${paginationObj?.sortObj?.sortOrder}`
        : "&orderby=DESC";
      const _isconsumerList = isConsumerList;

      const response = await _get(
        `${base_url}/${_orgClientId()}/campaign/customers?${_searchby}${_limit}${_offset}${_status}${_orderby}&isList=${_isconsumerList}`,
      );

      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const {
        data: consumerLists,
        error,
        message,
        status,
        statusCode,
        responseType,
      } = CustomSuccess(response, {
        ...config,
        disableToast: true,
      });
      // setTimeout(() => {
      if (!disableLoader) thunkAPI.dispatch(setPerformaLoading(false));
      // }, 3000);
      return {
        consumerLists,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      if (!disableLoader) thunkAPI.dispatch(setPerformaLoading(false));
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const fetchConsumerListWithEventTag = createAsyncThunk(
  "consumersList/fetchConsumerListWithEventTag",
  async ({ disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Fetched Consumer successfully.",
        errorMessage: "Failed to fetch consumer!",
      };

      const response = await _get(
        // `${base_url}/${_orgClientId()}/campaign/customers?status=default`,
        `${base_url}/event/list?clientId=${_orgClientId()}`,
      );

      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const {
        data: consumerLists,
        error,
        message,
        status,
        statusCode,
        responseType,
      } = CustomSuccess(response, {
        ...config,
        disableToast: true,
      });
      // setTimeout(() => {
      if (!disableLoader) thunkAPI.dispatch(setLoaderFalse());
      // }, 3000);
      return {
        consumerLists,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      if (!disableLoader) thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const createConsumerList = createAsyncThunk(
  "consumersList/createConsumerList",
  async ({ data, isConsumerList, disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Created consumer list successfully.",
        errorMessage: "Failed to create consumer list!",
      };
      const response = await _post(
        `${base_url}/${_orgClientId()}/campaign/customers`,
        data,
        config,
      );
      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }

      const {
        data: customerlistId,
        error,
        message,
        status,
        statusCode,
        responseType,
      } = CustomSuccess(response, {
        ...config,
        disableToast: true,
      });
      thunkAPI.dispatch(setLoaderFalse());
      return {
        customerlistId,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (err) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const updateConsumerList = createAsyncThunk(
  "consumersList/updateConsumerList",
  async (
    {
      data,
      selectedRowId,
      orgClientId,
      isConsumerList,
      paginationObj,
      cardName,
      disableLoader,
    },
    thunkAPI,
  ) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Updated Consumer successfully.",
        errorMessage: "Failed to update consumer!",
      };

      const response = await _put(
        `${base_url}/${_orgClientId()}/campaign/customers/${selectedRowId}`,
        data,
        config,
      );

      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const _response = CustomSuccess(response, {
        ...config,
        disableToast: true,
      });
      if (isConsumerList) {
        await thunkAPI.dispatch(
          fetchConsumerList({
            paginationObj,
            isConsumerList,
            cardName: cardName,
          }),
        );
      }
      thunkAPI.dispatch(setLoaderFalse());
      return _response;
    } catch (err) {
      if (!disableLoader) thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const deleteConsumerList = createAsyncThunk(
  "consumersList/deleteConsumerList",
  async (
    { paginationObj, selectedRowId, disableLoader, isConsumerList, cardName },
    thunkAPI,
  ) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setPerformaLoading(true));
      const config = {
        successMessage: "Consumer List deleted successfully!",
        errorMessage: "Failed to delete consumer!",
      };

      const response = await _delete(
        `${base_url}/${_orgClientId()}/campaign/customers/${selectedRowId}`,
        config,
      );

      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }

      // const _response = CustomSuccess(response, {
      //   ...config,
      //   ...(isConsumerList ? {} : { disableToast: true }), //old code
      // });

      const _response = CustomSuccess(response, {
        ...config,
        disableToast: true,
      });
      if (isConsumerList) {
        await thunkAPI.dispatch(
          fetchConsumerList({
            paginationObj,
            isConsumerList,
            cardName: cardName,
          }),
        );
      }
      thunkAPI.dispatch(setPerformaLoading(false));
      // thunkAPI.dispatch(setLoaderFalse());
      return _response;
    } catch (err) {
      if (!disableLoader) thunkAPI.dispatch(setPerformaLoading(false));
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const consumerListSlice = createSlice({
  name: "consumersList",
  initialState: initialConsumerListState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsumerList.pending, () => ({
        isLoading: API_STATUS.STATUS_LOADING,
      }))
      .addCase(fetchConsumerList.fulfilled, (_state, action) => ({
        isLoading: API_STATUS.STATUS_SUCCESS,
        consumerList: action.payload?.consumerLists?.consumerLists,
        totalCount: action.payload?.consumerLists?.totalCount,
      }))
      .addCase(fetchConsumerList.rejected, (_state, action) => {
        return {
          isLoading: API_STATUS.STATUS_FAILURE,
          message: action.error.message || "Error while fetching consumerlist",
          consumerList: [],
        };
      });
  },
});

export const selectConsumerList = (_state) => _state?.consumerList;

export const {} = consumerListSlice.actions;
